export const DASHBOARD_MODE_LEADERSHIP = 'leadership';
export const DASHBOARD_MODE_FRONT_DESK = 'front_desk';

export const DASHBOARD_MODES = Object.freeze([
  DASHBOARD_MODE_LEADERSHIP,
  DASHBOARD_MODE_FRONT_DESK,
]);

export const DASHBOARD_MODE_SET = new Set(DASHBOARD_MODES);

export function normalizeDashboardMode(value, fallback = DASHBOARD_MODE_LEADERSHIP) {
  const normalized = String(value || '').trim().toLowerCase();
  if (DASHBOARD_MODE_SET.has(normalized)) return normalized;
  return fallback;
}
